/** M-Pesa account reference max length (STK AccountReference field). */
export const TRAVEL_PAYMENT_REF_MAX_LEN = 12;

const TRAVEL_REF_PREFIX = 'TR-';

/**
 * Paybill / STK account number for travel — {@code TR-{customerIdNo}}, e.g. TR-37871676 or TR-BK988412.
 * Passport letters are kept: GIS auto-receipting matches the ID against CLNT_ID_REG_NO.
 * Mirrors payment-service TravelPaymentReference.
 */
export function travelPaymentReference(customerIdNo) {
  const id = String(customerIdNo || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
  if (!id) return '';
  const ref = `${TRAVEL_REF_PREFIX}${id}`;
  if (ref.length <= TRAVEL_PAYMENT_REF_MAX_LEN) return ref;
  return `${TRAVEL_REF_PREFIX}${id.slice(-(TRAVEL_PAYMENT_REF_MAX_LEN - TRAVEL_REF_PREFIX.length))}`;
}
